import Vue from 'vue'
import VuePortal from '@linusborg/vue-simple-portal'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import Animator from '@/plugins/Animator'

/**
 * Plugins
 */

Vue.use(VueReCaptcha, {
	siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
	loaderOptions: { autoHideBadge: true }
})
Vue.use(VuePortal)
Vue.use(Animator)

/**
 * Filters
 */

// Convert empty values to dashes
Vue.filter('dashEmpty', v => v || '-')

// Add commas to numbers
Vue.filter('number', v => String(v).replace(/(\d)(?=(\d{3})+$)/g, '$1,'))

/**
 * Init
 */

Vue.config.productionTip = false
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
